@if (configData()) {
  <div class="navrail-top">
    <div class="logo">
      <span class="cdk-visually-hidden">Resource and Data Exchange</span>
    </div>
  </div>
  <mat-nav-list class="navrail-mid">
    <mat-list-item
      tabindex="0"
      (click)="this.toggle()"
      (keydown.enter)="this.toggle()"
      (keydown.space)="this.toggle()"
      #navtoggle
      class="navtoggle"
      role="button"
      [attr.aria-expanded]="this.expanded"
      aria-label="Toggle navigation menu"
    >
      <mat-icon aria-hidden="true">menu</mat-icon><span>Collapse Menu</span>
    </mat-list-item>
    @for (item of navRailItems; track item) {
      <mat-list-item [activated]="item.active()">
        <a [routerLink]="item.routerLink" [attr.aria-current]="item.active() ? 'page' : null">
          <mat-icon aria-hidden="true" class="material-symbols-outlined mat-24">{{ item.icon }}</mat-icon>
          <span>{{ item.name }}</span>
        </a>
      </mat-list-item>
    }
  </mat-nav-list>
}
